export var ExperimentVariant;
(function (ExperimentVariant) {
    /**
     * @description The "on" state
     */
    ExperimentVariant["AVAILABLE"] = "available";
    /**
     * @description The "off" state
     */
    ExperimentVariant["CONTROL"] = "control";
})(ExperimentVariant || (ExperimentVariant = {}));
//# sourceMappingURL=experiments.js.map